import { type ElementLabelProps } from '@blaze-shared/elements-domain';

import { type CommonFormFieldProps } from '../models/form-field';

export function extractCommonFormFields(element: {
  props: {
    content: { title?: Pick<ElementLabelProps, 'label' | 'enabled' | 'icon' | 'tooltip'> };
    styleConfig?: { styleName?: string };
  };
}): Pick<CommonFormFieldProps, 'label' | 'showLabel' | 'iconName' | 'tooltip'> & {
  styleName?: string;
} {
  const { title } = element.props.content;

  return {
    label: title?.label,
    showLabel: title?.enabled,
    iconName: title?.icon,
    tooltip: title?.tooltip,
    styleName: element.props.styleConfig?.styleName,
  };
}
